module.exports = __webpack_public_path__ + "img/1338725618.c8a777b5.jpg";